







import { Component, Prop, Vue } from 'vue-property-decorator';
import { OperatorModel } from '@/models/Operator';
import OperatorCard from './OperatorCard.vue';

@Component({
  components: {
    OperatorCard,
  },
})
export default class OperatorTip extends Vue {
    @Prop() private operator!: OperatorModel;

    get classByRarity() {
        return 'tip-operator-img ' + 'rarity' + String(this.operator.rarity) + '-border';
    }
}
